
import { useTranslation } from "react-i18next";
import Hero from "../../components/root/Hero";
import WhyCabil from "../../components/root/WhyCabil";
import HowItWorks from "../../components/root/HowItWorks";
import HumanExpertise from "../../components/root/HumanExpertise";
import WatchTimeRewards from "../../components/root/WatchTimeRewards";
import Testimonials from "../../components/root/Testimonials";
import backgroundImage from "../../assets/new images/Background.png";
import img1 from "../../assets/new images/howitworks1.png";
import img2 from "../../assets/new images/howitworks2.png";
import img3 from "../../assets/new images/howitworks3.png";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";
import { organizationSchema, websiteSchema, mobileAppSchema } from "../../utils/structuredData";

const Home = () => {
  const { t } = useTranslation();

  const steps = [
    { img: img1, title: t("howItWorks.step1Title"), desc: t("howItWorks.step1Desc") },
    { img: img2, title: t("howItWorks.step2Title"), desc: t("howItWorks.step2Desc") },
    { img: img3, title: t("howItWorks.step3Title"), desc: t("howItWorks.step3Desc") },
  ];

  return (
    <div className="font-sans overflow-x-hidden">
      <Seo
        {...SEO["/"]}
        path="/"
        jsonLd={[organizationSchema(), websiteSchema(), mobileAppSchema()]}
      />
      <Hero bgImage={backgroundImage}
        badgeText={`✨ ${t("hero.badge")}`}
        titleLines={[t("hero.title1"), t("hero.title2"), t("hero.title3")]}
        subtitle={t("hero.subtitle")}
        primary={{ label: t("hero.findMentor"), href: "/find-mentor" }}
        secondary={{ label: t("hero.tryAi"), href: "/ai-career" }}
        curveColor="#F9FAFB"
        heightClass="h-[100vh] min-h-[560px]"
        overlayClass="bg-gradient-to-b from-black/55 via-black/35 to-black/25"
        roundedButtons={true} />

      <WhyCabil />
      <HowItWorks
        title={t("howItWorks.title")}
        subtitle={t("howItWorks.subtitle")}
        steps={steps}
        accentColor="#EE5F2B" />
      <HumanExpertise />
      <WatchTimeRewards />
      <Testimonials />
    </div>
  );
};

export default Home;
